import { Button } from '../../atoms/Button';

/**
 * Deliberate-sign-out screen. Pure — never auto-logins; the consumer wires the
 * explicit log-in action (legacy PLA-511). Was `advisor-platform`'s `SignedOutPage`
 * presentation.
 */
export function SignedOutState({ onLogin }: { onLogin: () => void }) {
  return (
    <main className="mx-auto flex max-w-sm flex-col items-center gap-4 p-6 text-center">
      <h1 className="text-h5 text-text-primary">You&apos;ve been signed out</h1>
      <p className="text-text-primary">
        Your session has ended. Log back in to pick up where you left off.
      </p>
      <Button onClick={onLogin}>Log in</Button>
    </main>
  );
}
